import { apiUrl } from "./api";

export async function jozSpeak(text) {
  try {
    const response = await fetch(apiUrl("/api/voice/speech"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        input: String(text || "").slice(0, 1600),
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Joz speech service error:", response.status, errorText);
      throw new Error(errorText);
    }

    const blob = await response.blob();
    if (blob.size === 0) throw new Error("Empty audio blob returned");

    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    audio.play().catch((error) => console.warn("Audio play failed:", error));

    return audio;
  } catch (err) {
    console.warn("⚠️ Realtime voice failed, falling back to browser TTS:", err);

    const utter = new SpeechSynthesisUtterance(text);
    utter.rate = 0.95;
    utter.pitch = 1.1;
    utter.voice =
      speechSynthesis.getVoices().find(v => /female|alloy|en/i.test(v.name)) ||
      null;
    speechSynthesis.speak(utter);
  }
}
